import type { JSX } from 'react'

import { Icon } from 'atoms/Icon'
import { IconNames, IconSizes } from 'atoms/Icon/Icon.h'
import { COLOR } from 'vars/color'
import { AvatarCorners } from '../Avatar.h'
import {
  AvatarImageContainerSC,
  AvatarImageSC,
  AvatarSelectedSC,
} from './AvatarImage.styled'

export interface IAvatarImageProps {
  imageUrl: string
  width?: number
  height?: number
  corners?: AvatarCorners
  selected?: boolean
  onClick?: () => void
  hover?: boolean
}

export const AvatarImage = ({
  imageUrl,
  width,
  height,
  corners = AvatarCorners.CORNERS_ROUND,
  selected = false,
  onClick,
  hover = false,
}: IAvatarImageProps): JSX.Element => {
  return (
    <AvatarImageContainerSC
      width={width}
      height={height}
      corners={corners}
      selected={selected}
      onClick={onClick}
      hover={hover}
    >
      <AvatarImageSC src={imageUrl} corners={corners} />

      {selected && (
        <AvatarSelectedSC corners={corners}>
          <Icon
            name={IconNames.check}
            size={IconSizes.xxMedium}
            color={COLOR.TEXT_ICON_PRIMARY}
          />
        </AvatarSelectedSC>
      )}
    </AvatarImageContainerSC>
  )
}
